/* Copyright (c) 2017 Backpack Health LLC */

import * as _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const ProgressDots = (props) => (
  <div className="cmp-progressdots">
    {
      _.times(props.stepTotal).map((i) => {
        const stepClasses = classnames('dot', {
          'is-current': (i + 1) === props.currentStep,
        });
        return <div key={i} className={stepClasses} />;
      })
    }
  </div>
);
ProgressDots.propTypes = {
  stepTotal: PropTypes.number,
  currentStep: PropTypes.number,
};


export default ProgressDots;
